import { LogLevel } from "@azure/msal-browser";
import { getSettingValue } from "./component/utils/CommonUtils"
const clientId = getSettingValue("REACT_APP_CLIENT_ID")
const tenantId = getSettingValue("REACT_APP_TENANT_ID")

const getRedirectUri = () => {
  if (typeof window !== 'undefined' && window.location) {
    return `${window.location.origin}/authentication`;
  }
  return "/authentication";
};

const getPostLogoutRedirectUri = () => {
  if (typeof window !== 'undefined' && window.location) {
    return `${window.location.origin}/home`;
  }
  return "/home";
};

export const msalConfig = {
  auth: {
    clientId: clientId,
    authority:`https://login.microsoftonline.com/${tenantId}/`,
    redirectUri: getRedirectUri(),
    postLogoutRedirectUri: getPostLogoutRedirectUri(),
    navigateToLoginRequestUrl: true,
  },
  cache: {
    cacheLocation: "sessionStorage",
    storeAuthStateInCookie: false,
  },
  system: {
    allowRedirectInIframe: true,
    allowNativeBroker: false,
    windowHashTimeout: 60000,
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return;
        }
        switch (level) {
          case LogLevel.Error:
            console.error(message);
            return;
          case LogLevel.Info:
            console.log(message);
            return;
          case LogLevel.Verbose:
            console.debug(message);
            return;
          case LogLevel.Warning:
            console.warn(message);
            return;
          default:
            return;
        }
      },
    },
  },
};

export const loginRequest = {
  scopes: [
    "openid",
    "profile",
    "email",
    "offline_access",
    `${clientId}/.default`,
  ],
};

export const silentRequest = {
  scopes: [
    "openid",
    "profile",
    "email",
    "offline_access",
    `${clientId}/.default`,
  ],
  loginHint: "example@domain.net",
};
